
(function CartGuard(){
  /* ===================== CONFIG ===================== */
  const PHP_ENDPOINT      = 'https://shopify.api.nomilk.dev/einrum/locations-data.php';
  const ICELAND_COUNTRY   = 'IS';
  const ICELAND_WAREHOUSE = 'IS';
  const DK_WAREHOUSE      = 'DK';
  const CACHE_TTL         = 30_000; // ms
  const ERROR_TXT         = 'Ikke på lager i din region';

  /* ================= CUSTOMER CONTEXT ================ */
  let __CUSTOMER_CTX = null;
  function readCustomerCtx () {
    if (__CUSTOMER_CTX) return __CUSTOMER_CTX;
    __CUSTOMER_CTX = { loggedIn: false, tags: [] };
    const el = document.getElementById('customer-context');
    if (!el) {
      console.log('[CART] customer-context not found → guest context');
      return __CUSTOMER_CTX;
    }
    try {
      const data = JSON.parse(el.textContent || '{}');
      __CUSTOMER_CTX.loggedIn = !!data.loggedIn;
      __CUSTOMER_CTX.tags = Array.isArray(data.tags) ? data.tags.map(t => String(t).toLowerCase()) : [];
      console.log('[CART] customer ctx:', __CUSTOMER_CTX);
    } catch(e){
      console.log('[CART] customer-context parse error:', e);
    }
    return __CUSTOMER_CTX;
  }
  function isIcelandB2B() {
    const c = readCustomerCtx();
    const match = c.loggedIn && c.tags.some(t => t.includes('b2b-iceland'));
    console.log('[CART] isIcelandB2B =', match);
    return match;
  }

  /* ================= COUNTRY ========================= */
  function detectCountry () {
    const cookie = document.cookie.split('; ').find(c => c.startsWith('_shopify_country='));
    if (cookie)            return cookie.split('=')[1].toUpperCase();
    if (Shopify?.country)  return Shopify.country;
    if (Shopify?.locale)   return Shopify.locale.split('-').pop().toUpperCase();
    return DK_WAREHOUSE;   // fallback
  }
  let visitorCountry = detectCountry();
  console.log('[CART] visitorCountry =', visitorCountry);

  /* ================= STOCK CACHE/FETCH =============== */
  const stockCache = new Map(); // variantId → {IS, DK, ts}

  function normalizeStockRecord (rec) {
    const is = Number(rec?.IS ?? 0);
    const dk = Number(rec?.DK ?? 0);
    return { IS: Number.isFinite(is) ? is : 0, DK: Number.isFinite(dk) ? dk : 0 };
  }

  async function fetchStock (variantIds = []) {
    const idsToFetch = variantIds.filter(id => {
      const rec = stockCache.get(id);
      const stale = !rec || Date.now() - rec.ts > CACHE_TTL;
      console.log(`[CART] cache ${stale ? 'MISS' : 'HIT'} → ${id}`, rec || '');
      return stale;
    });
    if (!idsToFetch.length) {
      console.log('[CART] no stock fetch needed for', variantIds);
      return;
    }

    console.log('[CART] fetching stock for', idsToFetch);
    const res  = await fetch(PHP_ENDPOINT, {
      method : 'POST',
      headers: {'Content-Type':'application/json'},
      body   : JSON.stringify({ variantIds: idsToFetch })
    });
    if (!res.ok) {
      console.warn('[CART] fetch failed status', res.status);
      return;
    }
    const raw = await res.json();
    console.log('[CART] raw payload', raw);

    Object.entries(raw).forEach(([idStr, payload]) => {
      const id = Number(idStr);
      const norm = normalizeStockRecord(payload);
      stockCache.set(id, { ...norm, ts: Date.now() });
      console.log('[CART] cached variant', id, '→', stockCache.get(id));
    });
  }

  /* ================= RULES =========================== */
  function availableQtyFor (variantId) {
    const rec = stockCache.get(variantId);
    if (!rec) {
      console.log('[CART] qty unknown for variant', variantId, '(no cache yet)');
      return null;
    }
    const isIS = visitorCountry === ICELAND_COUNTRY;
    const isQty = Math.max(0, +rec[ICELAND_WAREHOUSE] || 0);
    const dkQty = Math.max(0, +rec[DK_WAREHOUSE] || 0);

    if (isIS && !isIcelandB2B()) {
      console.log('[CART] rule: IS retail → IS only | IS=', isQty);
      return isQty;
    }
    if (isIS && isIcelandB2B()) {
      console.log('[CART] rule: IS B2B → pooled IS+DK | IS=', isQty, 'DK=', dkQty, 'TOTAL=', isQty + dkQty);
      return isQty + dkQty;
    }
    console.log('[CART] rule: outside IS → DK only | DK=', dkQty);
    return dkQty;
  }

  function allowedToBuy (variantId, qtyNeeded = 1) {
    const qty = availableQtyFor(variantId);
    if (qty === null) {
      console.log('[CART] optimistic allow (no data yet) for variant', variantId);
      return true;
    }
    const ok = qty >= qtyNeeded;
    console.log(`[CART] allowedToBuy? variant=${variantId} need=${qtyNeeded} have=${qty} → ${ok}`);
    return ok;
  }

  /* ================= DOM HELPERS ===================== */
  function cartRows () {
    return [...document.querySelectorAll('tr.cart-item')].filter(isSharedDelivery);
  }

  function rowTags(row) {
    const raw = row?.dataset?.tags;
    if (!raw) return [];
    try {
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.map(t => String(t).trim().toLowerCase()) : [];
    } catch {
      return [];
    }
  }
  function isSharedDelivery(row) {
    return rowTags(row).includes('shared-delivery');
  }

  function rowVariantId (row) {
    const data = Number(row?.dataset?.variantId);
    if (data) return data;
    const link = row.querySelector('a[href*="variant="]')?.href || '';
    const v = link ? Number(new URL(link).searchParams.get('variant')) : 0;
    return v || null;
  }
  function rowQtyInput (row) {
    return row.querySelector('.quantity__input');
  }
  function rowPlusBtn (row) {
    return row.querySelector('.quantity__button[name="plus"], .quantity__button-plus, .quantity__button.no-js-hidden[name="plus"]');
  }
  function rowMinusBtn (row) {
    return row.querySelector('.quantity__button[name="minus"], .quantity__button-minus, .quantity__button.no-js-hidden[name="minus"]');
  }
  function rowErrBox (row) {
    return row.querySelector('.cart-item__error-text');
  }
  function setRowError(row, msg) {
    const el = rowErrBox(row);
    if (el) el.textContent = msg;
    row.classList.add('error');
  }
  function clearRowError(row) {
    const el = rowErrBox(row);
    if (el) el.textContent = '';
    row.classList.remove('error');
  }

  /* ============ REFRESH A SINGLE ROW ================ */
  function refreshRowControls (row) {
    if (!isSharedDelivery(row)) {
      // Ensure we don't leave artificial limits/errors on non-guarded items
      const inp = rowQtyInput(row);
      if (inp) inp.removeAttribute('max');
      clearRowError(row);
      return;
    }

    const vId   = rowVariantId(row);
    const inp   = rowQtyInput(row);
    const plus  = rowPlusBtn(row);
    const minus = rowMinusBtn(row);

    if (!vId || !inp) return;

    const min = Number(inp.getAttribute('min')) || 0; // cart allows 0 to remove
    const avail = availableQtyFor(vId);

    if (avail === null) {
      // Unknown yet → keep controls free but no explicit max
      inp.removeAttribute('max');
      if (plus)  plus.classList.remove('disabled');
      if (minus) minus.classList.toggle('disabled', (Number(inp.value)||0) <= min);
      clearRowError(row);
      console.log('[CART] row', vId, 'pending stock; leaving controls open');
      return;
    }

    const max = Math.max(0, Number(avail) || 0);
    inp.setAttribute('max', String(max));

    let cur = Number(inp.value);
    if (!Number.isFinite(cur)) cur = min;

    // Clamp current value into [min..max]
    const clamped = Math.min(Math.max(cur, min), max);
    if (String(inp.value) !== String(clamped)) {
      inp.value = String(clamped);
    }

    const atMax = clamped >= max;
    const atMin = clamped <= min;

    if (plus)  plus.classList.toggle('disabled', atMax);
    if (minus) minus.classList.toggle('disabled', atMin);

    if (clamped < cur && max < cur) {
      setRowError(row, ERROR_TXT);
    } else {
      clearRowError(row);
    }

    console.log('[CART] row', vId, { min, max, cur, clamped, atMin, atMax });
  }

  /* ============ REFRESH ALL ROWS ==================== */
  function collectVariantIdsFromCart () {
    const ids = cartRows().map(rowVariantId).filter(Boolean); // only shared-delivery rows
    console.log('[CART] collected variant ids', ids);
    return ids;
  }

  async function refreshAllRows () {
    const ids = collectVariantIdsFromCart();
    if (ids.length) await fetchStock(ids);
    cartRows().forEach(refreshRowControls);
  }

  /* ============ EVENTS / ENFORCEMENT ================= */
  function bindCartEvents () {
    const root = document;

    // Click on +/- : fetch freshest for that line, then refresh, and prevent overflow
    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('.quantity__button');
      if (!btn) return;

      const row = e.target.closest('tr.cart-item');
      if (!row) return;
      if (!isSharedDelivery(row)) return;

      const vId = rowVariantId(row);
      if (!vId) return;

      console.log('[CART] +/- clicked for variant', vId, '| name=', btn.getAttribute('name'));
      await fetchStock([vId]);
      refreshRowControls(row);

      if (btn.getAttribute('name') === 'plus') {
        const inp = rowQtyInput(row);
        const max = Number(inp.getAttribute('max'));
        const next = (Number(inp.value) || 0) + 1;
        if (Number.isFinite(max) && next > max) {
          e.preventDefault();
          e.stopPropagation();
          setRowError(row, ERROR_TXT);
          console.log('[CART] blocked plus for variant', vId, 'next=', next, 'max=', max);
        }
      }
    });

    // Manual typing → clamp on input
    root.addEventListener('input', (e) => {
      const inp = e.target.closest('.quantity__input');
      if (!inp) return;
      const row  = inp.closest('tr.cart-item');
      if (!isSharedDelivery(row)) return;

      const vId  = rowVariantId(row);
      if (!vId) return;

      const min = Number(inp.getAttribute('min')) || 0;
      const maxAttr = inp.getAttribute('max');
      const max = maxAttr != null ? Number(maxAttr) : Infinity;
      let val = Number(inp.value);
      if (!Number.isFinite(val)) val = min;
      val = Math.min(Math.max(val, min), max);
      if (String(inp.value) !== String(val)) inp.value = String(val);

      refreshRowControls(row);
      console.log('[CART] manual input variant', vId, '→', val, '(min:', min, 'max:', max, ')');
    });

    // Form submit: guarantee values are within limits
    const form = document.querySelector('form[action="/cart"]') || document.querySelector('form[action*="/cart"]');
    if (form) {
      form.addEventListener('submit', (e) => {
        let changed = false;
        cartRows().forEach(row => {
          refreshRowControls(row); // ensure max exists + clamp applied
          const inp = rowQtyInput(row);
          const maxAttr = inp?.getAttribute('max');
          if (!inp || maxAttr == null) return;
          const max = Number(maxAttr);
          let val = Number(inp.value) || 0;
          if (val > max) {
            inp.value = String(max);
            setRowError(row, ERROR_TXT);
            changed = true;
            console.log('[CART] submit clamp variant', rowVariantId(row), '→', max);
          }
        });
        // If you prefer to block submit when any line exceeds max, uncomment:
        // if (changed) e.preventDefault();
      });
    }
  }

  /* ============ COUNTRY WATCHER (optional) =========== */
  setInterval(() => {
    const cur = detectCountry();
    if (cur !== visitorCountry) {
      console.log('[CART] country changed', visitorCountry, '→', cur);
      visitorCountry = cur;
      refreshAllRows();
    }
  }, 10_000);

  /* ============ INIT ================================ */
  async function init () {
    console.log('[CART] init');
    bindCartEvents();
    await refreshAllRows();
    console.log('[CART] ready');
  }

  if (document.readyState === 'complete') init();
  else {
    window.addEventListener('load', init);
    document.addEventListener('DOMContentLoaded', init);
  }
})();
